function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4853 3.51605C18.2188 1.24957 15.2053 0.00134277 12 0.00134277C8.79474 0.00134277 5.78119 1.24957 3.51471 3.51605C1.24823 5.78253 0 8.79608 0 12.0013C0 15.2066 1.24823 18.2202 3.51471 20.4866C5.78119 22.7531 8.79474 24.0013 12 24.0013C15.2053 24.0013 18.2188 22.7531 20.4853 20.4866C22.7518 18.2202 24 15.2066 24 12.0013C24 8.79608 22.7518 5.78253 20.4853 3.51605ZM12 22.1263C6.41711 22.1263 1.875 17.5842 1.875 12.0013C1.875 6.41846 6.41711 1.87634 12 1.87634C17.5829 1.87634 22.125 6.41846 22.125 12.0013C22.125 17.5842 17.5829 22.1263 12 22.1263ZM12.9375 11.0629H17.1562V12.9379H12.9375V17.1567H11.0625V12.9379H6.84375V11.0629H11.0625V6.84418H12.9375V11.0629Z",
  fill: "#1C9CE4"
});

var SvgPlus = function SvgPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus.7ad52853.svg";
export { ForwardRef as ReactComponent };